export default __webpack_public_path__ + "static/media/logo.abadb54d.svg";